
<template>
  <div class="form">
    <form v-show="!$store.state.loading" class="login-form" :model="forms">
      <!-- <form-item label="账户名"> -->
      <input type="text" placeholder="账户名" v-model="forms.name" />
      <!-- </form-item> -->
      <!-- <form-item label="密码"> -->
      <input type="password" placeholder="密码" v-model="forms.password" />
      <!-- </form-item> 如果button放在form里，那么回车即可触发事件，且页面刷新，放在form外则不会
          <button  v-show="!loading" @click="login" style="width: 100%;">登录</button> -->
    </form>
    <button  v-show="!$store.state.loading" @click="login" style="width: 100%;">登录</button>
          <!-- <div >
        <a style="float: right;margin-top:2em" @click="regist">注册账户</a>
      </div> -->
    <svg
      v-show="$store.state.loading"
      version="1.1"
      id="L9"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enable-background="new 0 0 0 0"
      xml:space="preserve"
    >
      <path
        fill="blue"
        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  </div>
</template>

<script>
import md5 from "md5";
import { itemscollection} from "@/components/utility/indexdb";
export default {
    data(){
        return {

            forms:{
                name:"",
                password:""
            }
        }
    },
    methods:{
          regist () {
      this.$emit('regist', 'Regist')
    },
    login(){
   
      this.$axios.dologin({name:this.forms.name,pass:md5(this.forms.password)})
      .then((tell)=>{
        itemscollection.remove({});
        this.$store.commit("reset")

        if(tell==="failed"){
          this.$message("用户名或密码错误");return}
        else{
          this.$router.push('/')
        window.location.reload()
        }

        })
    },
    
}
}
</script>


<style scoped>
.login-page {
  width: 360px;
  padding: 8% 0 0;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  /* background: white; */
  max-width: 360px;
  margin: 0 auto 100px;
  padding: 45px;
  text-align: center;
  /* box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24); */
}
.form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #5090f5;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.form button:hover,
.form button:active,
.form button:focus {
  background: #43a047;
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color: #5090f5;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/login/Login.vue